$('.btn-play').click(function(){
    // ocultamos el botón de play
    $(this).hide();
    // hacemos que el vídeo empiece
    $('.player video')[0].play();
});

$('.player video').on("pause", function(){
    // comprobamos que el vídeo está en pausa
    if (vrcardclosed === false && $(this).prop("readyState") == 4) {
        // comprobamos que el vídeo no haya terminado
        if (!$(this).prop("ended")) {
            setTimeout(function(){
                // nos aseguramos de que el vídeo está pausado
                if ($('.player video').prop("paused") || $('.player video').prop("readyState") == 4) {
                    // mostramos el banner
                    $('.resumecard__banner').show();
                    // motramos el overlay
                    $('#overlay-video').show();
                    // recreamos banner
                    recreateBanner();
                }
            }, 200);
        }
    }
});

function recreateBanner() {
    // reseteamos contador lazy
    lazyCount = 0;
    // borramos iframe previo de publicidad
    $('.resumecard__banner div').remove();
    $('.resumecard__banner iframe').remove();
    // agregamos iframe publicidad
    $('.resumecard__banner').append(vrcardTemp);
    blockId = $('.resumecard__banner div').attr('id');
    if (typeof _vrReload !== 'undefined' && _vrReload) {
        adBlockDetected(blockId);
    } else {
        adBlockNotDetected(blockId);
    }
}

$('.player video').on("play", function(){
    // ocultamos el overlay
    $('#overlay-video').hide();
});

$('.resumecard__video-control').click(function(){
    // continuamos con la reproducción
    $('.player video').trigger('play');
});

$('.resumecard__close').click(function(){
    vrcardclosed = true;
    // ocultamos el overlay
    $('#overlay-video').hide();
});